import React, { useState } from "react";
import Table from "../DetailExcoPusat/Table";
import DokumenKepengurusan from "../DetailExcoPusat/DokumenKepengurusan";
import DokumenLegalitas from "../DetailExcoPusat/DokumenLegalitas";
import DokumenKantor from "../DetailExcoPusat/DokumenKantor";
import DokumenBank from "../DetailExcoPusat/DokumenBank";
import BankKantor from "../DetailExcoPusat/BankKantor";
import { useSelector, useDispatch } from "react-redux";
import { getExcoDocument } from "../../../config/Redux/Global/actions";
import { getDetailExcoPusat } from "../../../config/Redux/ExcoPusat/actions";
import { useEffect } from "react";
// Import the SharedTabPanel component
import SharedTabPanel from "../../molecules/SharedTabPanel";
import { Paper } from "@mui/material";
import AlamatKantor from "../DetailExcoPusat/AlamatKantor";

const ProfileTabs = () => {
  const dispatch = useDispatch();
  const dataExcoPusat = useSelector((state) => state.excopusat.dataExcoPusat);
  const firstData = dataExcoPusat?.data?.data?.[0];
  const officeId = firstData?.id_kantor_exco;
  const tingkatExcoId = firstData?.tingkat_exco?.id || 1;
  const daerahId = firstData?.id_daerah;
  const isLocked = parseInt(firstData?.is_locked) === 1;

  const dataDoc = useSelector((state) => state.global.dataExcoDocument);

  const dataDocMap = dataDoc?.data;
  // console.log({ dataDocMap });

  useEffect(() => {
    if (officeId) {
      dispatch(getExcoDocument(officeId));
    }
    if (tingkatExcoId && daerahId) {
      dispatch(getDetailExcoPusat(tingkatExcoId, daerahId));
    }
  }, [dispatch, officeId, tingkatExcoId, daerahId]);

  // Filter logic copied from DetailExcoPusat/index.js
  let docPengurusan = dataDocMap?.filter(
    (item) =>
      item.kategori_dokumen.id === 1 ||
      item.kategori_dokumen.id === 2 ||
      item.kategori_dokumen.id === 9 ||
      item.kategori_dokumen.id === 7 ||
      item.kategori_dokumen.id === 8 ||
      item.kategori_dokumen.id === 10 ||
      item.kategori_dokumen.id === 11 ||
      item.kategori_dokumen.id === 12 ||
      item.kategori_dokumen.id === 13 ||
      item.kategori_dokumen.id === 14 ||
      item.kategori_dokumen.id === 16,
  );

  // Filter logic for Kantor (ID 3,4,5)
  let docKantor = dataDocMap?.filter(
    (item) =>
      item.kategori_dokumen.id === 3 ||
      item.kategori_dokumen.id === 4 ||
      item.kategori_dokumen.id === 5,
  );

  // Filter logic for Bank (ID 6, 15)
  let docBank = dataDocMap?.filter(
    (item) => item.kategori_dokumen.id === 6 || item.kategori_dokumen.id === 15,
  );

  const tabs = [
    {
      id: 0,
      label: "Daftar Kepengurusan",
      content: (
        <Table
          officeId={officeId}
          tingkatExcoId={tingkatExcoId}
          hideAddButton={isLocked ? true : false}
        />
      ),
    },
    {
      id: 1,
      label: "Dokumen Kepengurusan",
      content: (
        <DokumenKepengurusan
          dataDoc={docPengurusan}
          nameExco="EXCO Pusat"
          officeId={officeId}
          isLocked={isLocked}
          tingkatExcoId={tingkatExcoId}
        />
      ),
    },
    {
      id: 2,
      label: "Dokumen Legalitas",
      content: (
        <DokumenLegalitas
          dataDoc={docPengurusan}
          nameExco="EXCO Pusat"
          officeId={officeId}
          isLocked={isLocked}
          tingkatExcoId={tingkatExcoId}
        />
      ),
    },
    {
      id: 3,
      label: "Dokumen Kantor Tetap",
      content: (
        <>
          <Paper elevation={0} style={{ padding: 10 }}>
            <AlamatKantor
              officeId={officeId}
              tingkatExcoId={tingkatExcoId}
              daerahId={daerahId}
              isLocked={isLocked}
            />
            <DokumenKantor
              dataDoc={docKantor}
              nameExco="EXCO Pusat"
              officeId={officeId}
              isLocked={isLocked}
            />
          </Paper>
        </>
      ),
    },
    {
      id: 4,
      label: "Dokumen Rekening Bank",
      content: (
        <Paper elevation={0} style={{ padding: 10 }}>
          <BankKantor
            officeId={officeId}
            tingkatExcoId={tingkatExcoId}
            daerahId={daerahId}
            isLocked={isLocked}
          />
          <DokumenBank
            dataDoc={docBank}
            officeId={officeId}
            isLocked={isLocked}
          />
        </Paper>
      ),
    },
  ];

  // Logic is now separate from UI!
  return <SharedTabPanel tabs={tabs} />;
};

export default ProfileTabs;
